module.exports = __webpack_public_path__ + "img/2022-04-08_18-54-20.8931ba93.jpg";